import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Component } from 'react';
import { DynamicHead } from '../head';
export class CommonPageTDK extends Component {
    constructor() {
        super(...arguments);
        this.BaseContent = () => {
            return (_jsxs(DynamicHead, { children: [_jsx("title", { children: this.props.title }), _jsx("meta", { name: "description", content: this.props.description }), _jsx("meta", { name: "keywords", content: Array.isArray(this.props.keywords) ? this.props.keywords.join(',') : this.props.keywords })] }));
        };
    }
    render() {
        const { BaseContent, CanonicalLink } = this;
        return (_jsxs(_Fragment, { children: [_jsx(BaseContent, {}), _jsx(CanonicalLink, {})] }));
    }
}
